"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_LOGIN_FORM = exports.SUBMIT_SELF_REGISTRATION_FAILURE = exports.SUBMIT_SELF_REGISTRATION_SUCCESS = exports.SUBMIT_SELF_REGISTRATION_REQUEST = exports.SELF_REGISTER_FAILURE = exports.SELF_REGISTER_SUCCESS = exports.SELF_REGISTER_REQUEST = exports.SWITCH_TO_FAILURE = exports.SWITCH_TO_SUCCESS = exports.SWITCH_TO_REQUEST = exports.USER_VERIFY_FAILURE = exports.USER_VERIFY_SUCCESS = exports.USER_VERIFY_REQUEST = exports.READ_USER_DETAILS_FAILURE = exports.READ_USER_DETAILS_SUCCESS = exports.READ_USER_DETAILS_REQUEST = exports.USER_REGISTER_FAILURE = exports.USER_REGISTER_SUCCESS = exports.USER_REGISTER_REQUEST = exports.RESET_PASSWORD_FAILURE = exports.RESET_PASSWORD_SUCCESS = exports.RESET_PASSWORD_REQUEST = exports.REFRESH_TOKEN_FAILURE = exports.REFRESH_TOKEN_SUCCESS = exports.REFRESH_TOKEN_REQUEST = exports.DECODE_TOKEN_FAILURE = exports.DECODE_TOKEN_SUCCESS = exports.DECODE_TOKEN_REQUEST = exports.FORGOT_PASSWORD_FAILURE = exports.FORGOT_PASSWORD_SUCCESS = exports.FORGOT_PASSWORD_REQUEST = exports.LOG_OUT_FAILURE = exports.LOG_OUT_SUCCESS = exports.LOG_OUT_REQUEST = exports.LOG_IN_FAILURE = exports.LOG_IN_SUCCESS = exports.LOG_IN_REQUEST = exports.USER_DATA_RETRIEVAL_FAILURE = exports.USER_DATA_RETRIEVAL_SUCCESS = exports.USER_DATA_RETRIEVAL_REQUEST = exports.LOG_IN_PROCESS_FAILURE = exports.LOG_IN_PROCESS_SUCCESS = exports.LOG_IN_PROCESS_REQUEST = void 0;
var LOG_IN_PROCESS_REQUEST = 'LOG_IN_PROCESS_REQUEST';
exports.LOG_IN_PROCESS_REQUEST = LOG_IN_PROCESS_REQUEST;
var LOG_IN_PROCESS_SUCCESS = 'LOG_IN_PROCESS_SUCCESS';
exports.LOG_IN_PROCESS_SUCCESS = LOG_IN_PROCESS_SUCCESS;
var LOG_IN_PROCESS_FAILURE = 'LOG_IN_PROCESS_FAILURE';
exports.LOG_IN_PROCESS_FAILURE = LOG_IN_PROCESS_FAILURE;
var USER_DATA_RETRIEVAL_REQUEST = 'USER_DATA_RETRIEVAL_REQUEST';
exports.USER_DATA_RETRIEVAL_REQUEST = USER_DATA_RETRIEVAL_REQUEST;
var USER_DATA_RETRIEVAL_SUCCESS = 'USER_DATA_RETRIEVAL_SUCCESS';
exports.USER_DATA_RETRIEVAL_SUCCESS = USER_DATA_RETRIEVAL_SUCCESS;
var USER_DATA_RETRIEVAL_FAILURE = 'USER_DATA_RETRIEVAL_FAILURE';
exports.USER_DATA_RETRIEVAL_FAILURE = USER_DATA_RETRIEVAL_FAILURE;
var LOG_IN_REQUEST = 'LOG_IN_REQUEST';
exports.LOG_IN_REQUEST = LOG_IN_REQUEST;
var LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
exports.LOG_IN_SUCCESS = LOG_IN_SUCCESS;
var LOG_IN_FAILURE = 'LOG_IN_FAILURE';
exports.LOG_IN_FAILURE = LOG_IN_FAILURE;
var LOG_OUT_REQUEST = 'LOG_OUT_REQUEST';
exports.LOG_OUT_REQUEST = LOG_OUT_REQUEST;
var LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS';
exports.LOG_OUT_SUCCESS = LOG_OUT_SUCCESS;
var LOG_OUT_FAILURE = 'LOG_OUT_FAILURE';
exports.LOG_OUT_FAILURE = LOG_OUT_FAILURE;
var FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
exports.FORGOT_PASSWORD_REQUEST = FORGOT_PASSWORD_REQUEST;
var FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
exports.FORGOT_PASSWORD_SUCCESS = FORGOT_PASSWORD_SUCCESS;
var FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
exports.FORGOT_PASSWORD_FAILURE = FORGOT_PASSWORD_FAILURE;
var DECODE_TOKEN_REQUEST = 'DECODE_TOKEN_REQUEST';
exports.DECODE_TOKEN_REQUEST = DECODE_TOKEN_REQUEST;
var DECODE_TOKEN_SUCCESS = 'DECODE_TOKEN_SUCCESS';
exports.DECODE_TOKEN_SUCCESS = DECODE_TOKEN_SUCCESS;
var DECODE_TOKEN_FAILURE = 'DECODE_TOKEN_FAILURE';
exports.DECODE_TOKEN_FAILURE = DECODE_TOKEN_FAILURE;
var REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
exports.REFRESH_TOKEN_REQUEST = REFRESH_TOKEN_REQUEST;
var REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
exports.REFRESH_TOKEN_SUCCESS = REFRESH_TOKEN_SUCCESS;
var REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE';
exports.REFRESH_TOKEN_FAILURE = REFRESH_TOKEN_FAILURE;
var RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
exports.RESET_PASSWORD_REQUEST = RESET_PASSWORD_REQUEST;
var RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
exports.RESET_PASSWORD_SUCCESS = RESET_PASSWORD_SUCCESS;
var RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
exports.RESET_PASSWORD_FAILURE = RESET_PASSWORD_FAILURE;
var USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
exports.USER_REGISTER_REQUEST = USER_REGISTER_REQUEST;
var USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
exports.USER_REGISTER_SUCCESS = USER_REGISTER_SUCCESS;
var USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';
exports.USER_REGISTER_FAILURE = USER_REGISTER_FAILURE;
var READ_USER_DETAILS_REQUEST = 'READ_USER_DETAILS_REQUEST';
exports.READ_USER_DETAILS_REQUEST = READ_USER_DETAILS_REQUEST;
var READ_USER_DETAILS_SUCCESS = 'READ_USER_DETAILS_SUCCESS';
exports.READ_USER_DETAILS_SUCCESS = READ_USER_DETAILS_SUCCESS;
var READ_USER_DETAILS_FAILURE = 'READ_USER_DETAILS_FAILURE';
exports.READ_USER_DETAILS_FAILURE = READ_USER_DETAILS_FAILURE;
var USER_VERIFY_REQUEST = 'USER_VERIFY_REQUEST';
exports.USER_VERIFY_REQUEST = USER_VERIFY_REQUEST;
var USER_VERIFY_SUCCESS = 'USER_VERIFY_SUCCESS';
exports.USER_VERIFY_SUCCESS = USER_VERIFY_SUCCESS;
var USER_VERIFY_FAILURE = 'USER_VERIFY_FAILURE';
exports.USER_VERIFY_FAILURE = USER_VERIFY_FAILURE;
var SWITCH_TO_REQUEST = 'SWITCH_TO_REQUEST';
exports.SWITCH_TO_REQUEST = SWITCH_TO_REQUEST;
var SWITCH_TO_SUCCESS = 'SWITCH_TO_SUCCESS';
exports.SWITCH_TO_SUCCESS = SWITCH_TO_SUCCESS;
var SWITCH_TO_FAILURE = 'SWITCH_TO_FAILURE';
exports.SWITCH_TO_FAILURE = SWITCH_TO_FAILURE;
var SELF_REGISTER_REQUEST = 'SELF_REGISTER_REQUEST';
exports.SELF_REGISTER_REQUEST = SELF_REGISTER_REQUEST;
var SELF_REGISTER_SUCCESS = 'SELF_REGISTER_SUCCESS';
exports.SELF_REGISTER_SUCCESS = SELF_REGISTER_SUCCESS;
var SELF_REGISTER_FAILURE = 'SELF_REGISTER_FAILURE';
exports.SELF_REGISTER_FAILURE = SELF_REGISTER_FAILURE;
var SUBMIT_SELF_REGISTRATION_REQUEST = 'SUBMIT_SELF_REGISTRATION_REQUEST';
exports.SUBMIT_SELF_REGISTRATION_REQUEST = SUBMIT_SELF_REGISTRATION_REQUEST;
var SUBMIT_SELF_REGISTRATION_SUCCESS = 'SUBMIT_SELF_REGISTRATION_SUCCESS';
exports.SUBMIT_SELF_REGISTRATION_SUCCESS = SUBMIT_SELF_REGISTRATION_SUCCESS;
var SUBMIT_SELF_REGISTRATION_FAILURE = 'SUBMIT_SELF_REGISTRATION_FAILURE';
exports.SUBMIT_SELF_REGISTRATION_FAILURE = SUBMIT_SELF_REGISTRATION_FAILURE;
var CLEAR_LOGIN_FORM = 'CLEAR_LOGIN_FORM';
exports.CLEAR_LOGIN_FORM = CLEAR_LOGIN_FORM;